import React from 'react';

import { Alert } from '@mui/material';
import { Card } from '@mui/material';

import { Free2025Card } from './plan_cards/Free2025Card.jsx';
import { Premium2025Card } from './plan_cards/Premium2025Card.jsx';
import { SponsorUltimate2025Card } from './plan_cards/SponsorUltimate2025Card.jsx';



const AVAILABLE_CARDS = {
    // see billing.services.plans for IDs
    'free_2025': Free2025Card,
    'premium_2025': Premium2025Card,
    'sponsor_ultimate_2025': SponsorUltimate2025Card,
}


export const PlanCard = ({ plan, sx }) => {
    const cardMaxWidth = 290;
    const cardMinWidth = 200;

    let ChosenPlanCard = AVAILABLE_CARDS[plan.name];
    if (!ChosenPlanCard) {
       ChosenPlanCard = (
           <Alert severity="error">
               Подписки "{plan.name}" не существует, либо она стала архивной.
           </Alert>
       )
    }

    let isActive = false;
    if (plan.status?.till) {
        isActive = true;
    }

    return (
        <Card sx={{
            maxWidth: cardMaxWidth,
            minWidth: cardMinWidth,
            display: 'flex',
            flexFlow: 'column nowrap',
            backgroundColor: isActive ? 'rgba(211,246,211,0.5)': 'inherit',
            alignItems: 'stretch',
            justifyContent: 'start',
            ...sx,
        }}>
            <ChosenPlanCard plan={plan} />
        </Card>
    )
}
